// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
	{
		id: 1,
		title: 'Opportunity Odyssey | Job portal',
		category: 'Web Application',
		img: require('@/assets/images/Opportunity-Odyssey.png'),
		date: 'November 2024',
		overview: {
			description: 'A comprehensive job portal platform designed to connect job seekers with employers, featuring advanced search capabilities, user profiles, and application tracking.',
			technologies: ['Vue.js', 'Bootstrap'],
			challenge: 'Developed a robust job portal that streamlines the hiring process by connecting employers with potential candidates. The platform features real-time job posting updates, advanced search filters, and an intuitive application tracking system.'
		},
		images: [
			{
				id: 1,
				title: 'Job Portal Homepage',
				img: require('@/assets/images/Opportunity-Odyssey.png')
			},
			{
				id: 2,
				title: 'Job Search Interface',
				img: require('@/assets/images/Opportunity-Odyssey.png')
			},
			{
				id: 3,
				title: 'Application Dashboard',
				img: require('@/assets/images/Opportunity-Odyssey.png')
			}
		]
	},
	{
		id: 2,
		title: 'British Council | Learning Management System',
		category: 'Web Application',
		img: require('@/assets/images/BC-LMS.png'),
		date: 'September 2023',
		overview: {
			description: 'A comprehensive learning management system for British Council, providing interactive course content, student progress tracking, and assessment tools.',
			technologies: ['React.js', 'Django', 'PostgreSQL', 'Redux', 'Material-UI', 'AWS'],
			challenge: 'Built a scalable learning management system that handles thousands of concurrent users, featuring real-time progress tracking, interactive content delivery, and comprehensive assessment tools. The system includes video conferencing integration and automated grading capabilities.'
		},
		images: [
			{
				id: 1,
				title: 'LMS Dashboard',
				img: require('@/assets/images/BC-LMS.png')
			},
			{
				id: 2,
				title: 'Course View',
				img: require('@/assets/images/BC-LMS.png')
			},
			{
				id: 3,
				title: 'Assessment Interface',
				img: require('@/assets/images/BC-LMS.png')
			}
		]
	},
	{
		id: 3,
		title: 'CrypoVerse | Cryptocurrency Wallet & Exchange',
		category: 'Web Application',
		img: require('@/assets/images/Crypoverse.png'),
		date: 'December 2023',
		overview: {
			description: 'A secure and user-friendly cryptocurrency wallet and exchange platform, enabling users to manage, trade, and track their digital assets.',
			technologies: ['Next.js', 'Solidity', 'Web3.js', 'Ethereum', 'TailwindCSS', 'MetaMask Integration'],
			challenge: 'Developed a secure cryptocurrency platform that handles wallet management, real-time trading, and transaction tracking. Implemented robust security measures and integrated multiple blockchain networks while maintaining an intuitive user interface.'
		},
		images: [
			{
				id: 1,
				title: 'Crypto Dashboard',
				img: require('@/assets/images/Crypoverse.png')
			},
			{
				id: 2,
				title: 'Wallet Interface',
				img: require('@/assets/images/Crypoverse.png')
			},
			{
				id: 3,
				title: 'Trading View',
				img: require('@/assets/images/Crypoverse.png')
			}
		]
	},
	{
		id: 4,
		title: 'ToolBox | Web & Mobile application with integrated IoT Device & Sensors',
		category: 'Web Application',
		img: require('@/assets/images/ToolBox.png'),
		date: 'March 2024',
		overview: {
			description: 'An innovative IoT platform that connects and manages smart devices and sensors, providing real-time monitoring and control through web and mobile interfaces.',
			technologies: ['Vue.js', 'Python', 'MQTT', 'WebSocket', 'Docker', 'Raspberry Pi'],
			challenge: 'Created a comprehensive IoT platform that seamlessly integrates various sensors and devices, providing real-time data visualization and device control. Implemented robust data collection, analysis, and reporting features while ensuring scalability and reliability.'
		},
		images: [
			{
				id: 1,
				title: 'IoT Dashboard',
				img: require('@/assets/images/ToolBox.png')
			},
			{
				id: 2,
				title: 'Device Management',
				img: require('@/assets/images/ToolBox.png')
			},
			{
				id: 3,
				title: 'Sensor Analytics',
				img: require('@/assets/images/ToolBox.png')
			}
		]
	}
];

export default projects;
